<template>
  <footer>
    <section class="contact">
      <div class="container">
        <div class="flex">
          <div class="image">
            <Logo :width="120" :height="116" />
          </div>
          <div class="address">
            <strong>Pencils for Kids, Inc.</strong><br>
            11 Mission Palms Drive West<br>
            Rancho Mirage, CA 92270 USA
          </div>
          <div>
            <strong>Phone:</strong> +1 323-595-1693<br>
            <strong>Email:</strong> info@pencilsforkidsinc.com<br>
            &nbsp;
          </div>
        </div>
      </div>
    </section>
    <!-- <section class="mailingList">
      <div class="container">
        <div class="flex">
          <h2>Join our mailing list!</h2>
          <div class="form-group">
            <label class="sr-only">Email Address</label>
            <input class="form-control form-control-lg" placeholder="Enter your email address here" />
            <button class="btn btn-primary btn-lg">Sign Up</button>
          </div>
        </div>
      </div>
    </section> -->
    <section class="navigation">
      <div class="container">
        <div class="flex">
          <div>Copyright &copy; {{ year }} Pencils for Kids, Inc.</div>
          <ul class="nav">
            <li class="nav-item">
              <router-link to="/#donate" class="nav-link">Donate</router-link>
            </li>
            <li class="nav-item">
              <router-link to="/our-story" class="nav-link">Our Story</router-link>
            </li>
            <li class="nav-item">
              <router-link to="/#events" class="nav-link">Events</router-link>
            </li>
            <li class="nav-item">
              <router-link to="/gallery" class="nav-link">Gallery</router-link>
            </li>
            <li class="nav-item">
              <router-link to="/our-team" class="nav-link">Our Team</router-link>
            </li>
            <li class="nav-item">
              <router-link to="/#contact" class="nav-link">Contact</router-link>
            </li>
            <li class="nav-item">
              <router-link to="/privacy-policy" class="nav-link">Privacy Policy</router-link>
            </li>
          </ul>
        </div>
      </div>
    </section>
  </footer>
</template>

<script>
import Logo from './Logo'

export default {
  name: 'site-footer',
  components: {
    Logo
  },
  computed: {
    year() {
      return new Date().getFullYear()
    }
  }
}
</script>

<style lang="scss" scoped>
@import '~assets/styles/vars';

.contact {
  padding: 30px 0;
  background-color: white;
}

img {
  max-width: 100%;
}

.mailingList {
  padding: 40px 0;
  background-color: $gold;

  h2 {
    margin-bottom: 0;
  }

  .flex {
    align-items: center;

    .form-group {
      flex: 1;
      margin-bottom: 0;

      @include media('tablet') {
        display: flex;
      }

      .form-control {
        @include media('tablet') {
          margin: 0 1rem 0 3rem;
        }
      }
    }
  }
}

.navigation {
  padding: 20px 0;
  background-color: $dkBrown;
  color: $white;
  font-weight: 500;

  .nav {
    display: block;

    @include media('tablet') {
      display: inline-flex;
    }

    @include media('tablet-wide') {
      display: flex;
    }
  }

  .nav-link {
    font-size: 0.9rem;
    text-transform: uppercase;
    padding: 0;
    color: $white;

    @include media('tablet') {
      margin-left: 1.5rem;
    }

    @include media('desktop') {
      font-size: 1rem;
      letter-spacing: 1px;
    }

    &:hover,
    &:focus {
      color: $gold;
    }
  }
}

.flex {
  display: block;
  text-align: center;

  @include media('tablet-wide') {
    text-align: left;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
}
</style>



// WEBPACK FOOTER //
// SiteFooter.vue?37d7d299